import React, { useState, useEffect } from "react";
import "../../../assets/css/componentSpecificCss/checkout.css";

const CheckoutCreditsDisplay = ({ appliedCredits }) => {
  return (
    <li style={{
      display: "flex",
      justifyContent: "space-between",
      padding: "15px 10px",
      borderBottom: "1px solid #dedede"
    }}>
      <p style={{
        marginBottom: 0,
        fontFamily: "Open Sans, sans-serif"
      }}>
        Credits Applied
      </p>
      <span>- ${(appliedCredits / 100).toFixed(2)}</span>
    </li>
  );
};

export default CheckoutCreditsDisplay;